import axios from 'axios';
const API_URL = '/api/dept';

const resolveToken = (token) => token || sessionStorage.getItem('token');

const buildConfig = (token, M_ComCode, contentType) => {
	const resolvedToken = resolveToken(token);
	const headers = {};

	if (resolvedToken) {
		headers.Authorization = `Bearer ${resolvedToken}`;
	}
	if (M_ComCode) {
		headers['x-com-code'] = M_ComCode;
	}
	if (contentType) {
		headers['Content-Type'] = contentType;
	}

	return { headers };
};

export const getDepts = (M_ComCode, token) => axios.get(API_URL, buildConfig(token, M_ComCode));
export const getDept = (code, M_ComCode, token) => axios.get(`${API_URL}/${code}`, buildConfig(token, M_ComCode));
export const createDept = (data, M_ComCode, token) => axios.post(API_URL, data, buildConfig(token, M_ComCode));
export const updateDept = (code, data, M_ComCode, token) => axios.put(`${API_URL}/${code}`, data, buildConfig(token, M_ComCode));
export const deleteDept = (code, M_ComCode, token) => axios.delete(`${API_URL}/${code}`, buildConfig(token, M_ComCode));
export const refreshDeptHierarchy = (M_ComCode, token) => axios.post(`${API_URL}/refresh`, {}, buildConfig(token, M_ComCode));
